import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getEarnDashboard } from 'services/EarnService'

export const useEarnDashboardQuery = () => {
  return useQuery({
    queryKey: reactQueryKeys.earnDashboard(),
    queryFn: getEarnDashboard,
  })
}
